import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A domestic electricity meter on a backboard: a grey housing with a round
// glass register, a small display strip and an isolator switch below, fed by a
// conduit. The thing that counts the kilowatt-hours.
const BOARD = "#6e5a3a";
const BODY = "#cfd2d4";
const BODY_DK = "#aab0b6";
const GLASS = "#9fb6c2";
const DISPLAY = "#1f2a30";
const SWITCH = "#3a4046";

export const electricMeter = defineModel({
  id: "electric-meter",
  batchId: "electric",
  name: "Electric meter",
  tags: ["prop", "electric", "power", "metering", "consumer"],
  summary: "A kWh meter with a round register on a backboard.",
  footprint: 0.2,
  parts(): Part[] {
    return [
      // Backboard on a short stand.
      { geometry: new THREE.BoxGeometry(0.06, 0.7, 0.06), color: "#5a4a30", position: [0, 0.35, -0.04] },
      { geometry: new THREE.BoxGeometry(0.34, 0.5, 0.04), color: BOARD, position: [0, 0.55, -0.02] },
      // Meter housing.
      { geometry: new THREE.BoxGeometry(0.24, 0.3, 0.12), color: BODY, position: [0, 0.62, 0.06] },
      { geometry: new THREE.BoxGeometry(0.24, 0.04, 0.12), color: BODY_DK, position: [0, 0.78, 0.06] },
      // Round glass register.
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.04, 14), color: GLASS, position: [0, 0.66, 0.13], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.07, 0.01, 4, 14), color: BODY_DK, position: [0, 0.66, 0.135], rotation: [Math.PI / 2, 0, 0] },
      // Digit display strip.
      { geometry: new THREE.BoxGeometry(0.16, 0.04, 0.02), color: DISPLAY, position: [0, 0.55, 0.13] },
      // Isolator switch below, with conduit.
      { geometry: new THREE.BoxGeometry(0.12, 0.12, 0.1), color: SWITCH, position: [0, 0.4, 0.05] },
      { geometry: new THREE.BoxGeometry(0.03, 0.05, 0.03), color: "#cfcfcf", position: [0, 0.4, 0.11] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.28, 8), color: BODY_DK, position: [0.12, 0.5, 0.04] },
    ];
  },
  animations: [],
});
